import React from 'react';

const StatusBadge = ({ status }) => {
  const statusMap = {
    pending: { class: 'badge-pending', label: 'Pending' },
    in_transit: { class: 'badge-in-transit', label: 'In Transit' },
    'in transit': { class: 'badge-in-transit', label: 'In Transit' },
    delivered: { class: 'badge-delivered', label: 'Delivered' },
    cancelled: { class: 'badge-cancelled', label: 'Cancelled' },
    draft: { class: 'badge-draft', label: 'Draft' },
    sent: { class: 'badge-sent', label: 'Sent' },
    paid: { class: 'badge-paid', label: 'Paid' },
    overdue: { class: 'badge-overdue', label: 'Overdue' },
  };

  const statusLower = String(status).toLowerCase().trim();
  const config = statusMap[statusLower] || { class: 'badge-draft', label: status };

  return (
    <span className={`badge ${config.class}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
